import './index.css'

function Logo({url}){
    return <a href={url}><img alt='mako' src='../images/logo.png' className='logo'></img></a>
}

export default Logo